module.exports = __webpack_public_path__ + "static/media/ru.911c03c2.svg";